module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/a0123-msyokuba/msyokuba.component.css
// module id = ./src/app/a0123-msyokuba/msyokuba.component.css
// module chunks = main